import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

type Mode = 'products' | 'services';

interface VendorTypeGuardProps {
  allow: Mode;
  children: React.ReactNode;
}

/**
 * Prevent vendors from accessing sections not allowed by vendorType.
 * - service_vendor: services only
 * - product_vendor: products only
 * - general_vendor: both
 */
export function VendorTypeGuard({ allow, children }: VendorTypeGuardProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <>{children}</>;

  const vendorType = user?.vendorType ?? 'general_vendor';
  const allowed =
    vendorType === 'general_vendor' ||
    (vendorType === 'service_vendor' && allow === 'services') ||
    (vendorType === 'product_vendor' && allow === 'products');

  if (!allowed) {
    return <Navigate to="/vendor" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

